import React from "react";
import { PageTitle, Panel } from "../components/ui";
import { useI18n } from "../i18n";

const TERMS = [
  ["ISO 14064", "Sera gazı emisyonlarının hesaplanması ve doğrulanmasına ilişkin uluslararası standart."],
  ["GHG Protocol", "Sera gazı muhasebesi için en yaygın kullanılan küresel standart."],
  ["Kapsam 1", "Kuruluşun doğrudan kontrolündeki kaynaklardan çıkan emisyonlar (yakıt, araç)."],
  ["Kapsam 2", "Satın alınan elektrik, ısıtma ve soğutmadan kaynaklanan dolaylı emisyonlar."],
  ["Kapsam 3", "Değer zinciri boyunca oluşan diğer tüm dolaylı emisyonlar."],
  ["CBAM", "AB Sınırda Karbon Düzenleme Mekanizması — ithalatta karbon yükümlülüğü."],
  ["ESRS", "Avrupa Sürdürülebilirlik Raporlama Standartları (CSRD kapsamında)."],
  ["GRI", "Küresel Raporlama Girişimi sürdürülebilirlik açıklama standartları."],
  ["CO₂e", "Karbondioksit eşdeğeri — farklı gazların ısınma etkisinin ortak birimi."],
  ["Baz yıl", "Emisyon azaltım hedeflerinin karşılaştırıldığı referans yıl."],
];

export default function Glossary() {
  const { t } = useI18n();
  return (
    <div data-testid="glossary-page">
      <PageTitle title={t("glossary")} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {TERMS.map(([term, def]) => (
          <Panel key={term}>
            <div className="font-display text-lg text-[#14512f]">{term}</div>
            <p className="mt-1 text-sm text-[#4b544c]">{def}</p>
          </Panel>
        ))}
      </div>
    </div>
  );
}
